/**
 * Facet WP plugin scripts
 */

import $ from 'jquery';
import { lazyLoadObserve } from './lazyLoad';
import Jump from 'jump.js'
import { easeOutQuad } from 'ez.js';

if (typeof FWP === 'object') {
  let hasRefreshed = false;
  $(document).on('facetwp-loaded', function () {
    const defaultObserver = lazyLoadObserve();
    defaultObserver.observe();

    const fwpPager = document.querySelectorAll('.facetwp-page');
    fwpPager.forEach((pager) => {
      pager.addEventListener('click', function () {
        hasRefreshed = true;
      })
    })

    if (hasRefreshed) {
      Jump('.main', {
        duration: 800,
        easing: easeOutQuad,
      });
    }
  });
}
